import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Dec 17 2019
 * @author Tomas Leity
 */
import * as React from 'react';
import Icon, { IconType } from '../../media/Icon';
import translate from '../../i18n/translate';
import AppAlertStyled from './styled/AppAlertStyled';
import { CONSTANTS } from '../../../constants';
/**
 * @component AppAlert
 */

var AppAlert =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AppAlert, _React$PureComponent);

  function AppAlert(props) {
    var _this;

    _classCallCheck(this, AppAlert);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppAlert).call(this, props));
    _this.state = {
      enabled: CONSTANTS.APP_ALERT.enabled,
      message: CONSTANTS.APP_ALERT.message,
      type: CONSTANTS.APP_ALERT.type
    };
    return _this;
  }

  _createClass(AppAlert, [{
    key: "render",
    value: function render() {
      if (!this.state.enabled) {
        return null;
      }

      return React.createElement(AppAlertStyled, {
        type: this.state.type,
        className: this.props.className
      }, React.createElement("div", {
        className: 'alert-icon'
      }, React.createElement(Icon, {
        iconType: IconType.alert,
        iconHeight: 30
      })), React.createElement("div", {
        className: 'alert-content'
      }, translate(this.state.message)));
    }
  }]);

  return AppAlert;
}(React.PureComponent);

export { AppAlert as default };